export const isEntryDuplicateException = (error: any) => {
  return error?.data?.code === 'EntryDuplicate'
}